import styled from 'styled-components';
import { withStyles } from '@material-ui/core/styles';
import MuiAppBar from '@material-ui/core/AppBar';

export const AppBar = withStyles({
  root: {
    background: '#fff',
    boxShadow: '0px 7px 20px rgba(0, 0, 0, 0.05)',
    minHeight: '68px',
  },
})(MuiAppBar);

export const Wrapper = styled.div`
  width: 100%;
  max-width: 1108px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Logo = styled.img`
  width: 120px;
`;

export const HelpCenterLink = styled.a`
  font-size: 14px;
  color: #013e3e;
  text-decoration: none;
`;
